export const statusToText = (
  status: string,
  transactionType: string
): string => {
  if (transactionType === 'card-transaction') {
    if (status?.toUpperCase() === 'COMPLETED') return 'Completed';
    if (status?.toUpperCase() === 'REJECTED') return 'Rejected';
  }

  switch (status.toUpperCase()) {
    case 'DEPOSITED':
    case 'PENDING':
    case 'SENT':
    case 'SWAPPING':
    case 'SWAPPED':
    case 'RECEIVED':
    case 'RECEIVING':
      return 'Pending';

    case 'PROCESSING':
    case 'SENDING':
    case 'APPROVED':
      return 'Processing';

    case 'SUCCESS':
    case 'COMPLETED':
    case 'PROCESSED':
      return 'Completed';

    case 'REFUNDED':
      return 'Refunded';

    case 'FAILED':
    case 'FAILED_ON_START':
    case 'FAILED_AFTER_RECEIVED':
    case 'FAILED_MEXC_DEPOSIT':
    case 'FAILED_MEXC_WITHDRAW':
    case 'FAILED_MEXC_ORDER_CREATE':
    case 'FAILED_MEXC_ORDER_CANCEL':
    case 'CANCELED_BY_USER':
      return 'Failed';

    case 'AMOUNT REJECTED':
    case 'REJECTED':
      return 'Blocked';

    default:
      return status?.toLowerCase()?.replaceAll('_', ' ');
  }
};
